module.exports = __webpack_public_path__ + "img/merk-leute.d0d07243.jpg";